import React from "react";
import { Form, Input, Card, Space } from "antd";
import { CreditCardOutlined, UserOutlined, SafetyCertificateOutlined } from "@ant-design/icons";

const { TextArea } = Input;

// Constants with icons for better visual appeal
const PAYMENT_OPTIONS = [
  {
    label: "Self-Pay",
    value: "Self-Pay",
    icon: <CreditCardOutlined />,
    description: "Pay directly for services"
  },
  {
    label: "Membership",
    value: "Membership",
    icon: <UserOutlined />,
    description: "Use membership benefits"
  },
  {
    label: "Insurance",
    value: "Insurance",
    icon: <SafetyCertificateOutlined />,
    description: "Insurance coverage"
  },
];

const PaymentServicesSection = () => {
  const form = Form.useFormInstance();
  const selectedPayment = Form.useWatch("payment_services", form) || "Self-Pay";

  const handleSelect = (value) => {
    form.setFieldValue("payment_services", value);
  };

  // Set initial value if not already set
  React.useEffect(() => {
    if (!form.getFieldValue("payment_services")) {
      form.setFieldValue("payment_services", "Self-Pay");
    }
  }, [form]);

  return (
    <div className="w-full">
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Payment & Services</h3>
        <p className="text-gray-600 text-sm">Choose your preferred payment method and add any additional notes</p>
      </div>

      <Form.Item name="payment_services">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          {PAYMENT_OPTIONS.map((option) => (
            <Card
              key={option.value}
              className={`cursor-pointer transition-all duration-200 hover:shadow-lg border-2 ${selectedPayment === option.value
                  ? 'border-blue-500 bg-blue-50 shadow-md'
                  : 'border-gray-200 hover:border-gray-300'
                }`}
              bodyStyle={{ padding: '20px' }}
              onClick={() => handleSelect(option.value)}
            >
              <div className="text-center">
                <div className={`text-2xl mb-3 ${selectedPayment === option.value ? 'text-blue-600' : 'text-gray-500'
                  }`}>
                  {option.icon}
                </div>
                <h4 className={`font-semibold mb-1 ${selectedPayment === option.value ? 'text-blue-700' : 'text-gray-700'
                  }`}>
                  {option.label}
                </h4>
                <p className="text-xs text-gray-500">{option.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </Form.Item>

      <Form.Item
        name="payment_services_notes"
        label={
          <span className="text-gray-700 font-medium">Additional Notes</span>
        }
        className="mb-0"
      >
        <TextArea
          placeholder="Add any special instructions, insurance details, or payment preferences..."
          showCount
          maxLength={300}
          rows={4}
          className="resize-none"
          style={{
            borderRadius: '8px',
            border: '1px solid #d1d5db'
          }}
        />
      </Form.Item>
    </div>
  );
};

export default React.memo(PaymentServicesSection);
